import { render, staticRenderFns } from "./MyAgent.vue?vue&type=template&id=4a19f79e&scoped=true"
import script from "./MyAgent.vue?vue&type=script&lang=js"
export * from "./MyAgent.vue?vue&type=script&lang=js"
import style0 from "./MyAgent.vue?vue&type=style&index=0&id=4a19f79e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a19f79e",
  null
  
)

export default component.exports